export default __webpack_public_path__ + "static/media/img1DarkEn.80273112.png";